import { LanguageLevel } from '@/constants/languageLevel';

export function getLanguageLevelPercentage(
  level: LanguageLevel | null
): number {
  if (!level) return 0;

  const mappedLevel = levelMapping[level] || level;

  switch (mappedLevel) {
    case LanguageLevel.VeryBeginner:
      return 0;
    case LanguageLevel.Beginner:
      return 25;
    case LanguageLevel.Intermediate:
      return 50;
    case LanguageLevel.Advanced:
      return 75;
    case LanguageLevel.Native:
      return 100;
    default:
      return 0; // Default to 0 if level is unrecognized
  }
}

export const levelMapping: { [key: string]: LanguageLevel } = {
  'Very Beginner': LanguageLevel.VeryBeginner,
  Beginner: LanguageLevel.Beginner,
  Intermediate: LanguageLevel.Intermediate,
  Advanced: LanguageLevel.Advanced,
  Native: LanguageLevel.Native,
  A1: LanguageLevel.VeryBeginner,
  A2: LanguageLevel.Beginner,
  B1: LanguageLevel.Intermediate,
  B2: LanguageLevel.Intermediate,
  C1: LanguageLevel.Advanced,
  C2: LanguageLevel.Advanced,
  'CLB 0': LanguageLevel.VeryBeginner,
  'CLB 1': LanguageLevel.VeryBeginner,
  'CLB 2': LanguageLevel.Beginner,
  'CLB 3': LanguageLevel.Beginner,
  'CLB 4': LanguageLevel.Beginner,
  'CLB 5': LanguageLevel.Intermediate,
  'CLB 6': LanguageLevel.Intermediate,
  'CLB 7': LanguageLevel.Intermediate,
  'CLB 8': LanguageLevel.Advanced,
  'CLB 9': LanguageLevel.Advanced,
  'CLB 10': LanguageLevel.Advanced,
  'CLB 11': LanguageLevel.Advanced,
  'CLB 12': LanguageLevel.Advanced,
};

// Sort languages and prepare display text
export const shortLanguageDisplay = (languages: string[] | undefined) => {
  if (!languages || languages.length === 0) return '';

  // Sort languages to deprioritize English and French
  const sortedLanguages = [...languages].sort((a, b) => {
    if (a === 'English' || a === 'French') return 1;
    if (b === 'English' || b === 'French') return -1;
    return 0;
  });

  return sortedLanguages.length > 1
    ? `${sortedLanguages[0]} +${sortedLanguages.length - 1}`
    : sortedLanguages[0];
};
